// Mirrors the mgmt-api monthly-enrollment validation: enrolled lives is a whole
// headcount of at least 1. A 0 month would zero that month's accommodation
// attachment, so the API rejects it with a 400.

export const MIN_ENROLLED_LIVES = 1;

export type EnrolledLivesInput =
  | { kind: "clear" }
  | { kind: "lives"; lives: number }
  | { kind: "invalid"; error: string };

/**
 * Parses a typed headcount. Blank clears the month. Anything other than a plain
 * whole number (scientific notation like "1e21", decimals, signs) is invalid, as
 * is a count below MIN_ENROLLED_LIVES.
 */
export const parseEnrolledLives = (raw: string): EnrolledLivesInput => {
  const trimmed = raw.trim();
  if (trimmed === "") return { kind: "clear" };
  const lives = /^\d+$/.test(trimmed) ? parseInt(trimmed, 10) : NaN;
  if (!Number.isSafeInteger(lives)) return { kind: "invalid", error: "Enter a whole number" };
  if (lives < MIN_ENROLLED_LIVES) return { kind: "invalid", error: `Must be ${MIN_ENROLLED_LIVES} or more` };
  return { kind: "lives", lives };
};
